import React, { Component } from 'react'
import { Flex } from 'antd-mobile'
import loadimg from '../assets/fonts/search.png'

export default class Folding extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hide: true
    }
  }
  toggle() {
    this.setState({
      hide: !this.state.hide
    })
  }
  render() {
    return (
      <React.Fragment>
        <Flex direction="column" align="stretch">
          <Flex.Item>
            <img
              style={{
                width: '40%',
                height: '100%',
                margin: '0 auto',
                marginTop: '20%',
                display: 'block',
                color: '#ccc'
              }}
              src={loadimg}
            />
          </Flex.Item>
          <Flex.Item
            style={{
              color: 'rgb(172, 166, 166)',
              fontSize: '16px',
              margin: '10% auto'
            }}
          >
            {' '}
            当前列表暂无数据{' '}
          </Flex.Item>
        </Flex>
      </React.Fragment>
    )
  }
}
